__turbopack_context__.v({
  "attribute": "JobCardStartup-module__gPGLjq__attribute",
  "attributeLabel": "JobCardStartup-module__gPGLjq__attributeLabel",
  "attributes": "JobCardStartup-module__gPGLjq__attributes",
  "avatarFallback": "JobCardStartup-module__gPGLjq__avatarFallback",
  "avatarImage": "JobCardStartup-module__gPGLjq__avatarImage",
  "avatarWrapper": "JobCardStartup-module__gPGLjq__avatarWrapper",
  "card": "JobCardStartup-module__gPGLjq__card",
  "emoji": "JobCardStartup-module__gPGLjq__emoji",
  "headings": "JobCardStartup-module__gPGLjq__headings",
  "name": "JobCardStartup-module__gPGLjq__name",
  "recruiterLogo": "JobCardStartup-module__gPGLjq__recruiterLogo",
  "root": "JobCardStartup-module__gPGLjq__root",
  "subtitle": "JobCardStartup-module__gPGLjq__subtitle",
  "title": "JobCardStartup-module__gPGLjq__title",
  "top": "JobCardStartup-module__gPGLjq__top",
});
